import { LocalStorageKeys } from '@/app.constants';
import { decodeToken, IToken } from './utils/authUtils';

const jwt = localStorage.getItem(LocalStorageKeys.jwt);
export interface IState {
  isAuthenticated: boolean;
  jwt: string;
  token: IToken | object;
}

export const store = {
  state: {
    isAuthenticated: false,
    jwt: '',
    token: {},
  } as IState,

  setJwt(jwtString: string): void {
    this.state.jwt = jwtString;
    localStorage.setItem(LocalStorageKeys.jwt, jwtString);
    _updateToken();
    _updateIsAuthenticated();
  },
  clearJwt(): void {
    this.state.jwt = '';
    localStorage.removeItem(LocalStorageKeys.jwt);
    _updateToken();
    _updateIsAuthenticated();
  },
};

function _updateToken() {
  store.state.token = decodeToken(store.state.jwt || '');
}

function _updateIsAuthenticated() {
  store.state.isAuthenticated = !!store.state.jwt;
}

(function initStore() {
  store.setJwt(jwt || '');
})();
